import { HttpClient } from '@angular/common/http';
import { ParamContext } from '../../service/param.context';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from '../../../environment.constants';
import { DataType } from '../model/data-type';
import { VariableType } from '../model/variable-type';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable()
export class OntologyService {

    constructor(
        private http: HttpClient,
        private paramContext: ParamContext
    ) {
    }

    getClasses(): Observable<string[]> {
        return this.http.get<string[]>(SERVER_API_URL + `crops/${this.paramContext.cropName}/classes?programUUID=${this.paramContext.programUUID}`);
    }

    getDataTypes(): Observable<DataType[]> {
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/data-types?programUUID=${this.paramContext.programUUID}`;
        return this.http.get<DataType[]>(url);
    }

    getNonSystemDataTypes(): Observable<DataType[]> {
        return this.getDataTypes().pipe(
            map((dataTypes: DataType[]) =>
                dataTypes.filter(dt => dt?.systemDataType !== true)
            )
        );
    }

    getVariableTypes(excludeRestrictedTypes: any): Observable<VariableType[]> {
        if (excludeRestrictedTypes) {
            return this.http.get<VariableType[]>(SERVER_API_URL + `crops/${this.paramContext.cropName}/variable-types?excludeRestrictedTypes=${excludeRestrictedTypes}&programUUID=${this.paramContext.programUUID}`);
        }
        return this.http.get<VariableType[]>(SERVER_API_URL + `crops/${this.paramContext.cropName}/variable-types?programUUID=${this.paramContext.programUUID}`);
    }

}
